import { gql, graphQuery } from "../../../shared/lib/graphql"

const UpdateChannelScriptMutation = gql`
  mutation($channel_module_name: String!, $script: String!) {
    updateChannelScript(
      input: { channel_module_name: $channel_module_name, script: $script }
    ) {
      script
      errors {
        attribute
        message
      }
    }
  }
`

const RunStepTestMutation = gql`
  mutation(
    $channel_module_name: String!
    $step_module_name: String!
    $step_field_slug: String
    $operation: StepOperationEnum!
    $step_body: StepRunBodyInput
  ) {
    runStepTest(
      input: {
        channel_module_name: $channel_module_name
        step_module_name: $step_module_name
        step_field_slug: $step_field_slug
        operation: $operation
        step_body: $step_body
      }
    ) {
      protocol_response
      errors {
        attribute
        message
      }
    }
  }
`

export function updateChannelScript(channel_module_name, script) {
  return graphQuery(UpdateChannelScriptMutation, {
    channel_module_name,
    script,
  })
}

export function RunStepTest(
  channel_module_name,
  step_module_name,
  step_field_slug,
  operation,
  step_body
) {
  return graphQuery(RunStepTestMutation, {
    channel_module_name,
    step_module_name,
    step_field_slug,
    operation,
    step_body,
  })
}
